const COMMUNITY = {
    COMMUNITY: {
        RESOURCE_ID: 'community',
    },
};

export default COMMUNITY;
